var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 782.88 296.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a37b50;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.22,174.19a26.51,26.51,0,0,0,5.18-15.31c0-25.94-42.62-47-95.2-47s-95.2,21-95.2,47C0,175.19,16.85,189.55,42.42,198,23.7,216.13,14.35,235.16,19.81,248.4c6.09,14.78,29.05,18.45,57.66,11.48-1.08,12.13,1.2,21.78,7.24,26.88,15,12.64,47.41-7.36,72.43-44.68,12.6-18.79,20.92-38.39,24.16-54.83A40.43,40.43,0,0,0,185.22,174.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M597.66,180.63a26.58,26.58,0,0,1-5.18-15.31c0-25.94,42.62-47,95.2-47s95.2,21,95.2,47c0,16.31-16.85,30.67-42.42,39.09,18.72,18.16,28.07,37.19,22.61,50.43C757,269.62,734,273.29,705.41,266.32c1.08,12.13-1.19,21.78-7.24,26.88-15,12.64-47.41-7.36-72.43-44.68-12.6-18.79-20.92-38.39-24.16-54.83A40.43,40.43,0,0,1,597.66,180.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.2,111.91s501.55-264.73,531,20.14C626.2,132.05,640.75,255.91,95.2,111.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.48,85.34a26.58,26.58,0,0,0-1.14-16.13c-10-23.92-57.47-26.83-106-6.49s-79.66,56.21-69.63,80.13c6.31,15,27.4,21.77,54.25,19.65-10.25,24-11.51,45.15-1.36,55.25C198,229,220.57,223.53,244.26,206c3.7,11.61,9.52,19.62,17.07,22,18.7,5.86,40.87-25.12,49.52-69.21,4.35-22.21,4.44-43.49,1.07-59.91A40.25,40.25,0,0,0,310.48,85.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M588.67,106.91a19.74,19.74,0,0,0-10.19-6.33c-18.73-4.38-41.11,22.85-50,60.81s-.9,72.3,17.83,76.68c11.78,2.76,25-7,35.4-24,9.95,16.59,22.11,26.56,32.59,24.85,11.71-1.9,18.24-17.86,18-39.69,8.58,2.83,15.92,2.81,20.63-.69,11.66-8.68,2.69-35.47-20-59.85-11.44-12.28-24.19-21.59-35.51-26.71A30.1,30.1,0,0,0,588.67,106.91Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset2);
export default __webpack_public_path__ + "static/media/Asset 2.4ace9192.svg";
export { ForwardRef as ReactComponent };